import { Badge } from '@/components/ui/badge';
import type { PickingListStatus, PickItemStatus, ShortageReason } from '../../types';

interface PickingListStatusBadgeProps {
  status: PickingListStatus;
}

const statusConfig: Record<PickingListStatus, { label: string; className: string }> = {
  pending: { label: 'Pending', className: 'bg-gray-500 hover:bg-gray-600 text-white' },
  assigned: { label: 'Assigned', className: 'bg-yellow-500 hover:bg-yellow-600 text-black' },
  in_progress: { label: 'In Progress', className: 'bg-blue-500 hover:bg-blue-600 text-white' },
  completed: { label: 'Completed', className: 'bg-green-500 hover:bg-green-600 text-white' },
  cancelled: { label: 'Cancelled', className: 'bg-red-500 hover:bg-red-600 text-white' },
};

export function PickingListStatusBadge({ status }: PickingListStatusBadgeProps) {
  const config = statusConfig[status] || { label: status, className: 'bg-gray-500' };
  return <Badge className={config.className}>{config.label}</Badge>;
}

interface PickItemStatusBadgeProps {
  status: PickItemStatus;
}

const itemStatusConfig: Record<PickItemStatus, { label: string; className: string }> = {
  pending: { label: 'Pending', className: 'bg-gray-500 hover:bg-gray-600 text-white' },
  picked: { label: 'Picked', className: 'bg-green-500 hover:bg-green-600 text-white' },
  partial: { label: 'Partial', className: 'bg-yellow-500 hover:bg-yellow-600 text-black' },
  short: { label: 'Short', className: 'bg-orange-500 hover:bg-orange-600 text-white' },
  skipped: { label: 'Skipped', className: 'bg-slate-500 hover:bg-slate-600 text-white' },
};

export function PickItemStatusBadge({ status }: PickItemStatusBadgeProps) {
  const config = itemStatusConfig[status] || { label: status, className: 'bg-gray-500' };
  return <Badge className={config.className}>{config.label}</Badge>;
}

interface ShortageReasonBadgeProps {
  reason: ShortageReason;
}

const shortageReasonLabels: Record<ShortageReason, string> = {
  not_found: 'Not Found',
  damaged: 'Damaged',
  reserved: 'Reserved',
  wrong_location: 'Wrong Location',
  count_error: 'Count Error',
  other: 'Other',
};

export function ShortageReasonBadge({ reason }: ShortageReasonBadgeProps) {
  const label = shortageReasonLabels[reason] || reason;
  return <Badge variant="outline" className="text-orange-600 border-orange-600">{label}</Badge>;
}
